// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"ReportByEmployeesPage_tableWrapper__36MDH","calendarTab":"ReportByEmployeesPage_calendarTab__2Ko0Y"};